// src/env.js
// export const BASE_URL = 'http://localhost:5000';
export const BASE_URL = 'https://backend.c4u-online.co.uk';
// export const BASE_URL = 'https://mygeotabaddin-backend-4pp72v-a7ed49-168-231-114-239.traefik.me';
export const API_URL = 'https://admin.c4u-online.co.uk';